import script from "./todayLive.vue?vue&type=script&setup=true&lang=js"
export * from "./todayLive.vue?vue&type=script&setup=true&lang=js"

import "./todayLive.vue?vue&type=style&index=0&id=06d4a1e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d4a1e3"]])

export default __exports__